function CamisetasHeader() {
    return (
        <section className="mb-0">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight border-l-4 border-red-500 pl-4 mb-3">
                Camisetas
            </h1>
            <p className="text-base sm:text-lg font-medium text-slate-400 max-w-2xl leading-relaxed">
                Un recorrido por las camisetas que vistieron al aguatero y acompañaron cada capítulo de la historia del club.
            </p>
        </section>
    );
}

export default CamisetasHeader;
